var map = {
	"./blog.yml": 183,
	"./cloud.yml": 184,
	"./color.yml": 185,
	"./country.yml": 186,
	"./dio.yml": 187,
	"./doc.yml": 188,
	"./emoji.yml": 189,
	"./git.yml": 190,
	"./icon.yml": 191,
	"./license.yml": 192,
	"./link.yml": 193,
	"./metrics.yml": 194,
	"./people.yml": 195,
	"./soft.yml": 196,
	"./src.yml": 197,
	"./status.yml": 198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 182;